export enum EnumPluginProvider {
  Claude = 'CLAUDE',
  ChatGpt = 'CHATGPT',
}
